<p-table #galleryAddressesTable [value]="galleryAddresses" dataKey="Id" [rowHover]="false"
  styleClass="p-datatable-gridlines p-datatable-striped"
  [globalFilterFields]="['Name', 'Address1', 'Address2', 'State']" selectionMode="single" [paginator]="false">
  <ng-template pTemplate="caption">
    <div class="table-header">
      <div class="row d-flex align-items-center">
        <div class="col-8">
          <div
            class="searchbox rounded-3 w-100 position-relative d-flex align-items-center flex-row-reverse border bg-white">
            <button type="button"
              class="bg-transparent border-0 py-2 px-3 d-flex align-items-center justify-content-center position-absolute">
              <i class="text-muted fa fa-search icon-block icon-block--search-blue is--small"></i>
            </button>
            <input type="text"
              class="form-control form-control-sm bg-transparent w-100 h-100 shadow-none border-0 px-3 py-2"
              (input)="galleryAddressesTable.filterGlobal($any($event.target).value, 'contains')"
              [placeholder]="'viewGalleryAddress.search' | transloco" />
            </div>
          </div>
          <div class="col-4">
            <div class="d-flex justify-content-end">
              <button pButton icon="fa fa-plus" [label]="'viewGalleryAddress.newAddress' | transloco"
                class="p-button p-button-secondary p-button-sm p-button-outlined" (click)="showAddressDialog()">
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template let-rowIndex="rowIndex" pTemplate="header">
      <tr>
        <th [pSortableColumn]="'Address1'">{{ 'viewGalleryAddress.address' | transloco }} <p-sortIcon [field]="'Address1'"></p-sortIcon></th>
        <th>
          <div class="d-flex justify-content-end">{{ 'viewGalleryAddress.action' | transloco }}</div>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
      <tr>
        <td>
          <div class="p-2">
            <!-- Display country, city, and state in a single line -->
            <div class="d-flex">
              <div>{{ rowData.Country }}</div>,
              <div>{{ rowData.City }}</div>,
              <div>{{ rowData.State }}</div>
            </div>
            <div class="d-flex">
              {{ rowData.Address1 }}<br>
              {{ rowData.Address2 }}
            </div>
            @if (rowData.SuburbTown || rowData.PostalCode) {
              <div class="d-flex">
                <div>{{ rowData.SuburbTown }}</div>
                <div>{{ rowData.PostalCode }}</div>
              </div>
            }
            <!-- Display AddressType in muted text and small font size -->
            <div class="text-muted small">
              {{ rowData.AddressType }}
            </div>
          </div>
        </td>
        <td>
          <div class="d-flex justify-content-end">
            <button pButton type="button" class="p-button p-button-sm me-1 p-button-outlined" icon="pi pi-pencil"
            (click)="editAddress(rowData)"></button>
            <button pButton type="button" class="p-button p-button-danger p-button-sm p-button-outlined"
            icon="pi pi-trash" (click)="deleteAddress(rowData)"></button>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="2">
          <div class="text-center">{{ 'viewGalleryAddress.noRecordsFound' | transloco }}</div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-dialog [header]="isEditMode ? ('viewGalleryAddress.editAddress' | transloco) : ('viewGalleryAddress.addAddress' | transloco)" [(visible)]="visible" [modal]="true"
    [style]="{ 'width': '480px' }" (onHide)="closeDialog()" position="center" [appendTo]="'body'">
    <form class="form" #AddressesForm="ngForm">
      <div class="p-fluid p-3">
        <div class="row">
          <div class="col-12 mb-2">
            <app-address-autocomplete [label]="'viewGalleryAddress.searchForGalleryAddress' | transloco"
              [placeholder]="'viewGalleryAddress.typeSuburbCityOrAddress' | transloco"
              (addressSelected)="onAddressSelected($event)">
            </app-address-autocomplete>
            <small class="text-muted">{{ 'viewGalleryAddress.searchToAutoFill' | transloco }}</small>
          </div>
          <div class="col-12 mb-2">
            <div class="form-group">
              <label class="form-label" for="Country">{{ 'viewGalleryAddress.country' | transloco }}</label>
              <input id="Country" type="text" class="form-control form-control-sm"
                [(ngModel)]="selectedGalleryAddress.Country" name="Country" [placeholder]="'viewGalleryAddress.enterCountry' | transloco" />
            </div>
          </div>
          <div class="col-6 mb-2">
            <div class="form-group">
              <label class="form-label" for="State">{{ 'viewGalleryAddress.state' | transloco }}</label>
              <input id="State" type="text" class="form-control form-control-sm"
                [(ngModel)]="selectedGalleryAddress.State" name="State" [placeholder]="'viewGalleryAddress.enterStateOrRegion' | transloco" />
            </div>
          </div>
          <div class="col-6 mb-2">
            <div class="form-group">
              <label class="form-label" for="City">{{ 'viewGalleryAddress.city' | transloco }}</label>
              <input id="City" type="text" class="form-control form-control-sm"
                [(ngModel)]="selectedGalleryAddress.City" name="City" [placeholder]="'viewGalleryAddress.enterCityOrTown' | transloco" />
            </div>
          </div>
        </div>
        <div class="p-field mt-2">
          <label class="form-label">{{ 'viewGalleryAddress.addressType' | transloco }}</label>
          <p-dropdown [(ngModel)]="selectedGalleryAddress.AddressType" name="AddressType" [options]="addressTypes"
          [placeholder]="'viewGalleryAddress.selectAddressType' | transloco" [disabled]="isAddressTypeDisabled"></p-dropdown>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="p-field mt-2">
              <label for="address1">{{ 'viewGalleryAddress.addressLine1' | transloco }}</label>
              <input type="text" id="address1" pInputText [placeholder]="'viewGalleryAddress.addressLine1' | transloco"
                class="form-control form-control-sm" [(ngModel)]="selectedGalleryAddress.Address1" name="address1" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="p-field mt-2">
                <label for="address2">{{ 'viewGalleryAddress.addressLine2' | transloco }}</label>
                <input type="text" id="address2" pInputText [placeholder]="'viewGalleryAddress.addressLine2' | transloco"
                  class="form-control form-control-sm" [(ngModel)]="selectedGalleryAddress.Address2" name="addressLine2" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <div class="p-field mt-2">
                  <label for="subrubTown">{{ 'viewGalleryAddress.suburbTown' | transloco }}</label>
                  <input id="subrubTown" type="text" pInputText [placeholder]="'viewGalleryAddress.suburbTownPlaceholder' | transloco" class="form-control form-control-sm"
                    [(ngModel)]="selectedGalleryAddress.SuburbTown" name="subrubTown" />
                  </div>
                </div>
                <div class="col-6">
                  <div class="p-field mt-2">
                    <label for="PostalCode">{{ 'viewGalleryAddress.postalCode' | transloco }}</label>
                    <input id="PostalCode" type="text" pInputText [placeholder]="'viewGalleryAddress.postalCode' | transloco" class="form-control form-control-sm"
                      [(ngModel)]="selectedGalleryAddress.PostalCode" name="PostalCode" required />
                    </div>
                  </div>
                </div>
                <button pButton type="button" class="w-100 d-block mx-auto mt-2 p-button-outlined" (click)="saveAddress($event)"
                [disabled]="!selectedGalleryAddress.Address1">{{ 'viewGalleryAddress.save' | transloco }}</button>
              </div>
            </form>
          </p-dialog>